import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DownloadProgressService } from '../../../_service/download-progress.service';
import { ToastrService } from 'ngx-toastr';
import { URLS } from '../../../constants/URLS';
import { CategoryService } from '../../../_service/category.service';
import { MycontentserviceService } from '../../../_service/mycontentservice.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { TVNavigationService } from 'src/app/_service/tv-navigation.service';
import { TVFocusMemoryService } from 'src/app/_service/tv-focus-memory.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-percategory',
  templateUrl: './percategory.component.html',
  styleUrls: ['./percategory.component.css']
})
export class PercategoryComponent implements OnInit, AfterViewInit, OnDestroy {
  /** Snapshot of the component's route — see category-movie for rationale. */
  private componentRoute: string = '';

  categoryData: any[];
  watchList: any[];
  channelId: String;
  @ViewChild('scroller') scroller: CdkVirtualScrollViewport;
  startIndex = 0;
  lastIndex = 20;
  videoList: any[] = [];
  isLoading:boolean=false;
  isSLoading:boolean = false;
  selectedCategoryName:string;
  user_id: string;
  videoCount: any;
  hasReachedEnd: boolean = false;
  item: string;
  categoryId: string;
  category: string;


  constructor(
    private categ: CategoryService,
    private mycontentService: MycontentserviceService,
    private route: ActivatedRoute,
    private router: Router,
    private el:ElementRef,
    private walletService: WalletinfoService,
    private cdr: ChangeDetectorRef,
    private tvNav: TVNavigationService,
    private focusMemory: TVFocusMemoryService,
    private deviceService: DeviceService
    ) { }

  ngOnInit(): void {
    this.el.nativeElement.addEventListener('scroll', this.onScroll.bind(this));

    const routeParams = this.route.snapshot.params;
    this.item = routeParams['item'];
    this.category = routeParams['category'];
    this.categoryId = routeParams['category_id'];

    console.log('Item:', this.item);
    console.log('Category ID:', this.categoryId);
    console.log('Category:', this.category);

    this.route.queryParams.subscribe(queryParams => {
      this.videoCount = Number(queryParams['count']) || 0;
    });

    if(this.videoCount && this.categoryId){
      this.getCategoryDataByChannelId();
    }else if(this.item !== 'section'){
      this.getWebData(this.item, this.category);
    }
  }

  ngAfterViewInit(): void {
    if (this.deviceService.isTV()) {
      this.componentRoute = this.router.url;
      setTimeout(() => {
        this.restoreTvFocus();
      }, 200);
    }
  }
  
  getCategoryDataByChannelId() {
    this.isSLoading = true;
    const userId = localStorage.getItem('userId');
    forkJoin({
      movies: this.categ.sectionsByCategoryAndChannelId(this.categoryId, this.startIndex, this.lastIndex),
      watchlist: this.mycontentService.getWatchListOfUser(userId),
      subscriptions: this.walletService.getUserSubscriptions(),
      watchHistory: this.mycontentService.getContinueWatching()
    }).subscribe(({ movies, watchlist, subscriptions, watchHistory }) => {
      if (movies) {
        this.categoryData = movies.map(section => {
          this.transformData(section);
          return section;
        });
        this.videoList = [...this.videoList || [], ...this.categoryData];
        this.mapwatchContent(watchlist);
        this.mapSubscription(subscriptions);
        this.mapwatchHistory(watchHistory);
      }
      this.isSLoading = false;
      this.cdr.detectChanges();
    }, (error) => {
      this.isSLoading = false;
      this.cdr.detectChanges();
    });
  }

  getWebData(type:string, category:string){
    this.isSLoading = true;
    const userId = localStorage.getItem('userId');
    forkJoin({
      movies: this.categ.getWebSearch(type, category),
      watchlist: this.mycontentService.getWatchListOfUser(userId),
      subscriptions: this.walletService.getUserSubscriptions(),
      watchHistory: this.mycontentService.getContinueWatching()
    }).subscribe(({ movies, watchlist, subscriptions, watchHistory }) => {
      if (movies.data?.length) {
        this.categoryData = movies.data.map(section => {
          this.transformData(section);
          return section;
        });
        this.mapwatchContent(watchlist);
        this.mapSubscription(subscriptions);
        this.mapwatchHistory(watchHistory);
      }
      this.isSLoading = false;
      this.cdr.detectChanges();
    }, (error) => {
      this.isSLoading = false;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void{
    this.el.nativeElement.removeEventListener('scroll', this.onScroll.bind(this));

    // Save focus position for TV mode
    if (this.deviceService.isTV()) {
      const regionId = this.tvNav.getActiveRegionId();
      const index = this.tvNav.getFocusedIndex();
      if (regionId) {
        this.focusMemory.saveFocusPosition({
          regionId,
          index,
          timestamp: Date.now(),
          route: this.componentRoute
        });
      }
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const totalHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
    const windowHeight = document.documentElement.clientHeight || document.body.clientHeight || 0;
  
    const threshold = 200; 
    if (scrollPosition + windowHeight >= totalHeight - threshold && !this.isSLoading && !this.hasReachedEnd && this.item === 'section'){
      this.loadMoreData(this.startIndex + 20, this.lastIndex + 20);
    }
  }

  loadMoreData(firstIndex: number, lastIndex: number) {
    if (this.isSLoading) return;
    if (this.videoList?.length >= this.videoCount) {
      console.log("No more videos to load");
      this.hasReachedEnd = true;
      return;
    }
    this.isSLoading = true;
    this.startIndex = firstIndex; 
    this.lastIndex = lastIndex;
    const userId = localStorage.getItem('userId');
    forkJoin({
      movies: this.categ.sectionsByCategoryAndChannelId(this.categoryId, this.startIndex, this.lastIndex),
      watchlist: this.mycontentService.getWatchListOfUser(userId),
      subscriptions: this.walletService.getUserSubscriptions(),
      watchHistory: this.mycontentService.getContinueWatching()
    }).subscribe(({movies, watchlist, subscriptions, watchHistory})=>{
      if(movies){
        this.videoList = movies;
        this.categoryData = this.videoList;
        this.categoryData = movies.map(section => {
          this.transformData(section);
          return section;
        });
        this.mapwatchContent(watchlist);
        this.mapSubscription(subscriptions);
        this.mapwatchHistory(watchHistory);
      }
      this.isSLoading = false;
      this.cdr.detectChanges(); 
    }, (error) => {
      this.isSLoading = false;
      this.cdr.detectChanges(); 
    })
  }

  mapwatchContent(watchresult: any[]) {
    this.categoryData.forEach(item => {
      item.isInWatchList = watchresult.some(wlitem => item.vidLibId == wlitem.vidLibId);
    });
  }

  mapwatchHistory(watchHistory: any[]) {
    this.categoryData.forEach(item => {
      const whitem = watchHistory.find(w => w.vidLibId == item.vidLibId);
      if (whitem) {
        item.watchedPercentage = whitem.watchedPercentage;
      }
    });    
  }
  
  mapSubscription(subscriptions: any[]) {
    this.categoryData.forEach(item => {
      item.expiringDate = '';
      subscriptions.forEach(sitem => {
        if (item.channelId == sitem.channelId && sitem.isActive) {
          item.isChannelSubscribed = true;
          item.expiringDate = sitem.dateOfExpiry;
        }
        if ((item.vidLibId == sitem.contentId || item.vidLibId == sitem.vidLibId) && sitem.isActive) {
          item.isPPVSubscribed = true;
          item.expiringDate = sitem.dateOfExpiry;
        }
      });
    });
  }

  transformData(data: any) {
    this.mycontentService.transformData(data);
  }

  removeDuplicates(data) {
    const tempObj = {};
    const finalResult = [];
    for(const ele of data) {
      if(!tempObj[ele.vidLibId]){
        finalResult.push(ele);
        tempObj[ele.vidLibId] = ele.vidLibId;
      }
    }
    return finalResult;
  }

  goBack() {
    window.history.back();
  }

  private restoreTvFocus(): void {
    // Priority: lastContentFocus (sidebar switch) > focus memory (route return) > default
    if (this.tvNav.hasLastContentFocus()) {
      return; // TVNavigationService handles sidebar-to-content restoration
    }

    const saved = this.focusMemory.restoreFocusPosition(this.router.url);
    if (saved) {
      this.tvNav.activateRegion(saved.regionId, saved.index);
    }
    // If no saved position, TVNavigationService auto-focuses first region via registerRegion()
  }
}